import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';

const Toggle = (_param)=>{
    var { id , className , checked: isChecked , disabled =false , onChange  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "id",
        "className",
        "checked",
        "disabled",
        "onChange"
    ]);
    const [checked, setChecked] = React.useState(isChecked);
    const handleOnChange = React.useCallback((e)=>{
        onChange(e.currentTarget.checked);
        setChecked(e.currentTarget.checked);
    }, [
        onChange
    ]);
    const handleKeyPress = React.useCallback((e)=>{
        if ((e.key === 'Enter' || e.key === 'Space') && !disabled) {
            onChange(!checked);
            setChecked(!checked);
        }
    }, [
        checked,
        disabled,
        onChange
    ]);
    return /*#__PURE__*/ React.createElement("label", swcHelpers.extends({}, rest, {
        className: classnames('toggle', className)
    }), /*#__PURE__*/ React.createElement("input", {
        id: id,
        className: "toggle__input",
        type: "checkbox",
        checked: checked,
        disabled: disabled,
        "aria-checked": checked,
        "aria-label": rest['aria-label'],
        onChange: handleOnChange,
        onKeyUp: handleKeyPress
    }), /*#__PURE__*/ React.createElement("span", {
        className: "toggle__slider"
    }));
};

export { Toggle as default };
//# sourceMappingURL=Toggle.js.map
